import React, { Dispatch, SetStateAction } from "react";
import { useHistory } from "react-router-dom";
import { TypePages } from ".";
import IconButton from "../../../../components/IconButton";
import Spinner from "../../../../components/Spinner";
import { IconCalendarWithPencil } from "../../../../icons";
import { convertDate } from "../../../../libs/dateUtils";
import { PointsByDayRange } from "../../model";
import { TitleMobile } from "../components/TitleMobile";

export default function HistoryPointsMobile({
  needSpinner,
  points,
  setPages,
  setDateRow,
}: {
  needSpinner: boolean;
  points: PointsByDayRange[];
  setPages: Dispatch<SetStateAction<TypePages>>;
  setDateRow: Dispatch<SetStateAction<string>>;
}) {
  const history = useHistory();

  const handleClickInRow = (point: PointsByDayRange) => {
    setDateRow(point.date);
    setPages("details");
  };

  return (
    <>
      <TitleMobile onClick={() => history.goBack()} title={"Histórico"} />
      <div className="flex flex-col justify-between mobile-table-box">
        <div className="-mx-8 bg-primary p-8 table-mobile-timesheet">
          <Spinner status={needSpinner} className="spinner-mobile-history-timesheet">
            <table className="w-full text-2rem font-familyPoppins ">
              <thead>
                <tr className="w-full">
                  <th className="text-left pl-8 text-white">Data</th>
                  <th className="text-right pr-16 text-white">Total</th>
                </tr>
              </thead>
              <tbody>
                {points?.map((point) => {
                  return (
                    <>
                      <tr
                        className="my-4 bg-white"
                        onClick={() => {
                          handleClickInRow(point);
                        }}
                      >
                        <td className="text-left text-2rem text-textPrimary rounded-l-xl p-8 ">{convertDate(point?.date)}</td>
                        <td className="text-right text-2rem text-textPrimary rounded-r-xl p-8 px-16 ">
                          {point?.workedTime} {point?.workedTime ? "hr" : ""}
                        </td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          </Spinner>
        </div>
        <div className="text-2rem flex justify-center items-center footer-history-timesheet-mobile">
          <IconButton
            icon={IconCalendarWithPencil}
            onClick={() => setPages("filter")}
            className="flex items-center justify-center w-32 h-32 rounded-full shadow-2xl border border-gray-700"
          />
        </div>
      </div>
    </>
  );
}
